(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminQuoteEditSettingsController', AdminQuoteEditSettingsController);

    function AdminQuoteEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'quote_timeout',
                'quote_terms_text',
                'quote_terms_file',
                'quote_require_labour_and_materials',
                'budget_quotes'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: (vm) => ({
                'quote_terms_file': {
                    type: 'file',
                    downloadTitle: 'TERMS_DOWNLOAD_TITLE',
                    downloadHref: vm.settings && vm.settings.quote_terms_file
                        ? vm.settings.quote_terms_file.value
                        : null,
                    fileName: vm.settings && vm.settings.quote_terms_file
                        ? vm.settings.quote_terms_file.filename
                        : null
                },
                'quote_terms_text': { type: 'cke-editor', rows: 5 },
                'quote_timeout': { type: 'number', subLabel: 'QUOTE_TIMEOUT_SUB_LABEL', min: 0, notRequired: true, options: { invalid: false} },
                'quote_require_labour_and_materials': { type: 'checkbox', subLabel: 'QUOTE_REQUIRE_LABOUR_AND_MATERIALS_ON_QUOTE_OPTIONS', notRequired: false },
                'budget_quotes': { type: 'checkbox', notRequired: false }
            })
        });

        angular.extend(vm, base);
    }
})();
